<template>
    <div>
        <h2>Генерация ссылки для автозаполнения анкеты</h2>
        <p>Введите userAccountId для генерации ссылки</p>
        <div class="questionnaire-autofill-container">
            <div class="centered questionnaire-autofill-input-container">
                <input type="text" class="input shedule-input" v-model="userAccountId" />
                <button @click="generateAutofillLink" class="button">
                    {{ 'Сгенерировать' }}
                </button>
            </div>

            <p v-if="this.autofillLink" class="questionnaire-autofill-generated-link">
                Ссылка: <b>{{ this.autofillLink }}</b>
            </p>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'QuestionnaireAutofill',
    mounted() {

    },
    data() {
        return {
            error: null,
            userAccountId: '',
            autofillLink: null,
        }
    },
    props: {

    },
    methods: {
        async generateAutofillLink() {
            const { data } = await this.axios
                .post('/uprid/autofill-link', { userAccountId: this.userAccountId })
                .catch((e) => {
                    console.log(e)
                })

            if (data) {
                this.autofillLink = data.link
            }
        },
    }
}
</script>
  
<style>
.questionnaire-autofill-container {
    display: flex;
    flex-direction: column;
    justify-content: left;
    align-items: flex-start;
}

.questionnaire-autofill-input-container {
    margin-bottom: 5px;
    margin-top: 3px;
}

.smev-requests-sync-input-container {
    margin-left: 0;
}
</style>
  


// WEBPACK FOOTER //
// QuestionnaireAutofill.vue?38e63102